<template lang="html">
  <StandardDialog @click-outside="$router.push({ name: 'ProjectOverView'})">
    <template #content>
      <!-- Flexbox: Dialog Content -->
      <TFlex style="width:100%; flex-direction: column; height:100%;overflow-y:hidden;" class="pa-5">
        <!-- Flexbox: Header +  Header Actions -->
        <TFlex style="width:100%;" justify_content="space-between" align_items="center">
          <TText
            size="20"
            font_weight="500"
            :text="getUObject({ type: 'multiprojects', id: multiproject_id}).name"
          />
          <TFlex justify_content="flex-end" gap="5px">
            <ButtonOutlined
              value="Done"
              padding="0 16px"
              @buttonClicked="$router.push({
                name: 'MultiProjectDetailsDialog',
                params: {
                  multiproject_id: multiproject_id
                }
              })"
            />
            <ButtonOutlined
              value="Close"
              padding="0 16px"
              @buttonClicked="$router.push({ name: 'ProjectOverView'})"
            />
            <!-- <v-btn @click="$router.push({
              name: 'MultiProjectDetailsDialog',
              params: {
                multiproject_id: multiproject_id
              }
            })">done</v-btn>
            <v-btn @click="$router.push({ name: 'ProjectOverView'})">Close</v-btn> -->
          </TFlex>
        </TFlex>
        <!-- Flexbox: Edit Projects -->
        <TFlex style="width:100%;height:100%">
          <!-- Flexbox: Added Projects / draggable -->
          <TFlex style="width:20%; flex-direction: column; height:100%;" class="pb-15">
            <TText
              size="18"
              font_weight="400"
              value="Projects"
            />
            <div
              v-for="project in getUObjects({ type: 'projects', ids: getUObject({ type: 'multiprojects', id: multiproject_id}).projects })"
              :key="`addproject_${project.id}`"
              class="multiproject-project"
            >
              <div
                class="multiproject-project-remove"
                @click="updateUObjectRelations({
                  url: [
                    {multiprojects: multiproject_id},
                  ],
                  /* url_prefix: `/projects/${project_id}/projectstructure`, */
                  target_type: 'projects',
                  target_ids: [project.id],
                  action: 'remove',
                  bidirectional: false
                })"
              >
                <span>x</span>
              </div>
              <div class="multiproject-project-name">
                {{ project.name }}
              </div>
            </div>
          </TFlex>
          <!-- Flexbox: ALL Projects -->
          <TFlex wrap="wrap" style="width:80%;height:100%;overflow-y:scroll;" class="pb-15">
            <ProjectCard
              v-for="project in getUObjects({ type: 'projects'})"
              :key="project.id"
              :width="`calc(${1/2} * (100% - 30px))`"
              :image="project.image ? project.image : ''"
              content_height="200px"
              height="300px"
              class="ma-1"
              :header="project.name"
              :project_information="project.information"
              :is_checked="getUObject({ type: 'multiprojects', id: multiproject_id}).projects.includes(project.id)"
              :checkbox="true"
              @clickAll="updateUObjectRelations({
                url: [
                  {multiprojects: multiproject_id},
                ],
                /* url_prefix: `/projects/${project_id}/projectstructure`, */
                target_type: 'projects',
                target_ids: [project.id],
                action: getUObject({ type: 'multiprojects', id: multiproject_id}).projects.includes(project.id)?'remove':'add',
                bidirectional: false
              })"
            >
              <template #image>
                {{project.name}}
              </template>
              <template #body>
                <div style="display: flex;" class="project-info-projectrole">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-col v-on="on" cols="2">
                        <v-row>
                          <v-icon>person</v-icon>
                          <div>{{project.prole}}</div>
                        </v-row>
                      </v-col>
                    </template>
                    <span></span>
                  </v-tooltip>
                  <div class="project-info-workpackages">
                    <!-- <WorkPackage
                      v-for="(work_package, index) in project.work_packages"
                      :key="index"
                      :color="`${work_package.color} ${work_package.color.includes('lighten') || work_package.color.includes('darken')? '':'lighten-1'}`"
                      :token="work_package.token"
                      :icon="work_package.icon"
                      :zoom="1"
                      >
                      <template #workpackage>
                        <StandardBadge
                          color="white"
                          :text="work_package.count"
                          content_color="black"
                        />
                      </template>
                    </WorkPackage> -->
                  </div>
                </div>
              </template>
            </ProjectCard>
          </TFlex>
        </TFlex>
      </TFlex>
    </template>
  </StandardDialog>
</template>

<script>

import {
  mapActions,
  mapGetters
} from 'vuex';

import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import ProjectCard from '@/components/ProjectOverView/ProjectCard.component.vue'
import TFlex from '@/components/Taktify/TFlex.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue'
// import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue'



export default {
  name: 'MultiProjectEditDialog',
  components: {
    ProjectCard,
    StandardDialog,
    TFlex,
    TText,
    ButtonOutlined,
    // WorkPackage
  },
  props: ['multiproject_id'],
  computed: {
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects',
    ]),
    ...mapGetters('Project', [
      'getProjectOverview',
    ]),
    columns(){
      if (this.$vuetify.breakpoint.smAndDown) {
        return 2;
      } else if(this.$vuetify.breakpoint.mdOnly) {
        return 3;
      } else {
        return 3;
      }
    }
  },
  methods: {
    ...mapActions('Ultra', [
      'updateUObjectRelations'
    ]),
    getCols(){
      if (this.$vuetify.breakpoint.smAndDown) {
        return 12;
      } else if(this.$vuetify.breakpoint.mdOnly) {
        return 6;
      } else {
        return 4;
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .multiproject-project {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 3px;
    margin-left: 0px;
    padding: 3px;
  }
  .multiproject-project-remove {
    border-width: 1px;
    border-style: solid;
    border-color: #f44336!important;
    border-radius: 4px;
    color: #f44336!important;
    width: 20px;
    cursor: pointer;
    padding-left: 5px;
  }
  .multiproject-project-name {
    border-width: 1px;
    border-style: solid;
    border-color: var(--primary-base);
    border-radius: 4px;
    width: calc(100% - 30px);
    margin-left: 5px;
    padding: 0px 5px;
    text-overflow: ellipsis;
  }
</style>
